import React from 'react';
import { useFormContext } from 'react-hook-form';
import FormField from '../FormField';
import municipios from '../../../data/municipios.json';

export default function IdentificacaoCaracterizacao() {
  const { setValue, watch } = useFormContext();

  // Observa mudanças no nome do município para preencher o código IBGE
  React.useEffect(() => {
    const nomeMunicipio = watch('nome_municipio');
    const municipio = municipios.find(m => m.municipio === nomeMunicipio);
    if (municipio) {
      setValue('codigo_ibge', municipio.codigo_ibge);
    } else if (nomeMunicipio === '') {
      setValue('codigo_ibge', '');
    }
  }, [watch('nome_municipio')]);

  return (
    <div>
      <div className="mb-6 p-4 bg-blue-50 rounded-lg">
        <p className="text-sm text-blue-700">Esta seção coleta informações básicas de identificação e caracterização geral do município. Preencha com os dados mais atualizados disponíveis.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FormField
          name="nome_municipio"
          label="Nome do município ou localidade"
          type="select"
          options={municipios.map(m => ({ value: m.municipio, label: m.municipio }))}
          className="[&_.input]:bg-gray-50"
          required
          helpText="Selecione o município da lista"
        />

        <FormField
          name="codigo_ibge"
          label="Código do Município (IBGE)"
          type="number"
          placeholder="Código será preenchido automaticamente"
          disabled
          className="cursor-not-allowed"
          helpText="Código de 7 dígitos do IBGE (preenchido automaticamente)"
        />
      </div>

      <div className="mt-4">
        <FormField
          name="secretaria_referencia"
          label="Secretaria ou órgão municipal de referência"
          placeholder="Digite a secretaria ou órgão de referência"
          helpText="Secretaria ou órgão municipal responsável pelas informações gerais"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <FormField
          name="area_territorial"
          label="Área territorial (km²)"
          type="numeric"
          thousandSeparator="."
          decimalSeparator=","
          suffix=" km²"
          placeholder="Digite a área territorial"
          helpText="Área territorial do município em quilômetros quadrados"
        />

        <FormField
          name="populacao_urbana"
          label="População urbana"
          type="numeric"
          thousandSeparator="."
          decimalSeparator=","
          placeholder="Digite a população urbana"
          helpText="Informe o valor e o ano de referência"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <FormField
          name="populacao_rural"
          label="População rural"
          type="numeric"
          thousandSeparator="."
          decimalSeparator=","
          placeholder="Digite a população rural"
          helpText="Informe o valor e o ano de referência"
        />

        <FormField
          name="densidade_demografica"
          label="Densidade demográfica (hab./km²)"
          type="decimal3"
          maxDecimalValue={null}
          placeholder="Digite a densidade demográfica"
          helpText="Densidade demográfica em habitantes por km²"
          validation={{
            validate: (value) => {
              if (value === undefined || value === '') return true;
              return (value >= 0) || 'O valor deve ser maior ou igual a 0';
            }
          }}
        />
      </div>

      <div className="mt-4">
        <FormField
          name="problemas_caracterizacao"
          label="Principais problemas gerais identificados"
          type="textarea"
          placeholder="Descreva os principais problemas gerais identificados, considerando crescimento desordenado, perda populacional, déficit de infraestrutura ou outros"
          helpText="Considere crescimento desordenado, perda populacional, déficit de infraestrutura ou outros"
          rows={4}
          className="[&_.input]:min-h-[8rem]"
        />
      </div>

      <div className="mt-4">
        <FormField
          name="demandas_caracterizacao"
          label="Demandas prioritárias identificadas"
          type="textarea"
          placeholder="Descreva as demandas prioritárias identificadas, considerando expansão urbana, atualização cadastral, planejamento territorial ou outras"
          helpText="Considere expansão urbana, atualização cadastral, planejamento territorial ou outras"
          rows={4}
          className="[&_.input]:min-h-[8rem]"
        />
      </div>

      <hr className="border-t border-gray-300 my-6" />
      <div className="mt-6 space-y-4">
        <FormField
          name="fontes_principais_secao1"
          label="Fontes principais"
          type="textarea"
          placeholder="Liste as principais fontes utilizadas nesta seção do formulário"
          helpText=""
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />

        <FormField
          name="links_acesso_secao1"
          label="Links de acesso"
          type="textarea"
          placeholder="Insira os links para acesso às fontes"
          helpText="Informe URLs para acesso às fontes quando disponível"
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />
      </div>
    </div>
  );
}
